import { useAuth0 } from '@auth0/auth0-react'
import { ButtonLink } from '@designsforhealth/dfh-react-components'
import React from 'react'
import styled from 'styled-components'

export interface LogoutLinkProps {
  className?: string
}

const LogoutLink: React.FC<LogoutLinkProps> = ({ className, children }) => {
  const { logout } = useAuth0()
  return (
    <ButtonLink
      className={className || undefined}
      onClick={() => {
        logout({
          returnTo: window.location.origin,
        })
      }}
    >
      {children}
    </ButtonLink>
  )
}

const StyledLogoutLink = styled(LogoutLink)`
  font-family: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  line-height: inherit;
`

export default StyledLogoutLink
